module.exports = __webpack_public_path__ + "static/media/corner-up-left.23fa01fa.svg";